import { Component, Input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import { GenericLinkDirective } from '@core/jss-utils';

@Component({
  selector: 'wl-horizontal-links-list',
  templateUrl: './horizontal-links-list.component.html',
  styleUrls: [
    './horizontal-links-list.component.essent.scss',
    './horizontal-links-list.component.ed.scss',
  ],
  standalone: true,
  imports: [GenericLinkDirective],
})
export class HorizontalLinksListComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
}
